import operationTypes from 'constants/operationTypes';

export const operationsPartnerBook = [
  operationTypes.CONSTITUTION,
  operationTypes.CAPITAL_INCREASE,
  operationTypes.CAPITAL_DECREASE,
  operationTypes.SELL_PARTICIPATION,
  operationTypes.HERITAGE,
  operationTypes.DONATION,
  operationTypes.ENDORSEMENT,
  operationTypes.TRANSMISSION,
  operationTypes.SPLIT,
  operationTypes.RENUMERATION,
];
